export default __webpack_public_path__ + "f6259e4ce1f8b71a58e4c461aebdf5d0.png";